export default {
  isOpen: true,
  showRemoveFontConfirmation: false,
  showMaxFontsOverlay: false,
  isLazyLoading: false,
  fontList: {},
  fontFamilyToRemove: ''
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/initial-state.js